module.exports = __webpack_public_path__ + "img/edasneowhite.bb6dd8c1.webp";